import React from 'react'
import { Box } from '@mui/material'
import { EmtTypography } from 'emt-components-v2'
import NextImage from 'next/image'

interface InfoProps {
  title: string
  text?: string
  image: string
}

export const Info: React.FC<InfoProps> = ({ image, title, text }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <NextImage src={image} alt={title} width={32} height={32} />
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
        <EmtTypography variant="body2" fontWeight="700">
          {title}
        </EmtTypography>
        {text && <EmtTypography variant="body2">{text}</EmtTypography>}
      </Box>
    </Box>
  )
}
